import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import t from '@zenlayer/zen-intl18';
import { Input, Modal, Space, Typography, Icon } from '@zenlayer/zen-design';
import { getExistPromotionCode } from '../../../api/summary';
import { useRequest } from 'ahooks';
import { FooterButton } from '@zenlayer/zen-design/esm/modal';
import { useState } from 'react';
import { getProductInfoForAlias } from '@zenlayer/portal-utils';
const Content = (props) => {
    const { productAlias, onClose, onApply, promoCode, setPromoCode } = props;
    const [value, onChange] = useState(promoCode);
    const productInfo = getProductInfoForAlias(productAlias);
    const ExistPromotionCodeRequest = useRequest((code) => getExistPromotionCode({ code, serviceSn: productInfo.serviceSn }), {
        manual: true,
        throttleWait: 500,
    });
    const existPromotionCode = ExistPromotionCodeRequest.data?.data;
    return (_jsxs(Space, { direction: "vertical", block: true, children: [_jsx("span", { children: t('YFtbrXEiY0dN') }), _jsx("span", { children: t('h0mbLJQcZ9ge') }), _jsx(Input, { type: "filled", label: t('DdhdZj5P4yxs'), value: value, onChange: (v) => {
                    console.log(v);
                    ExistPromotionCodeRequest.run(v);
                    onChange(v);
                }, suffix: ExistPromotionCodeRequest.loading ? (_jsx("div", { children: _jsx(Icon, { type: "LoadingOutlined", style: { display: 'block' } }) })) : undefined }), existPromotionCode === false && (_jsx(Typography.Text, { type: "error", size: "12-16", children: t('GjvljtU2f28O') })), _jsx(FooterButton, { okButtonText: t('lW6lfnEYNlqX'), cancelButtonText: null, okButtonProps: {
                    disabled: value === '' ||
                        value === undefined ||
                        value === promoCode ||
                        ExistPromotionCodeRequest.loading ||
                        existPromotionCode === false,
                }, onCancel: onClose, onOk: async () => {
                    const s = await onApply(value);
                    if (s === true) {
                        setPromoCode(value);
                    }
                    return s;
                } })] }));
};
export const useApplyPromo = () => {
    const [{ open, close }, widthContext] = Modal.useModal(true);
    const openApplyPromo = (props) => {
        open({
            title: t('RTpJ7cc8JE1m'),
            width: 444,
            closable: true,
            content: _jsx(Content, { onClose: close, ...props }),
            okButtonText: null,
            cancelButtonText: null,
        });
    };
    return {
        openApplyPromo,
        widthContext,
    };
};
